<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/fN0piK/tc-custom/9781685507053.jpg?1723406883139" alt="This image is the cover for the book Lieutenant's Love"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lieutenant's Love
      </h1>
      <p class="bookDescription body article font2">
        <p>Lieutenant Jarryd Alyt has given blood and soul in service to the Duke, yet suffering the loss of a beloved companion and best friend drives him near the brink of despair. Disillusioned though still loyal, when new recruit Arin arrives, Jarryd is struck by the youth’s innocence and beauty.<br/><br/>But will the horror of war strike before Jarryd summons the courage to love again?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Red Haircrow
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3cfd3663